import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import axios from "../../../../config/axios";
import useOnlineReservation from "../../hooks/useOnlineReservation";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { navigateTo } from "src/global/navigationHelper";

const OnlineReservationPayPage = () => {
  const { onlineReservation } = useOnlineReservation();
  const { token } = useParams();
  const { t } = useTranslation("reservations");
  const [loading, setLoading] = useState(true);

  function redirectToStripeCheckout() {
    if (onlineReservation.booking?.reservation_payment_type !== "stripe") {
      navigateTo(`/reservations/thank-you`);
      return;
    }

    axios
      .post(`/stripe/checkout_sessions`, { token: token })
      .then(({ data }) => {
        window.location.assign(data.url);
      })
      .catch((error) => {
        console.error(error);
        navigateTo(`/reservations/thank-you`);
      });
  }

  useEffect(() => {
    if (onlineReservation) {
      redirectToStripeCheckout();
    }
  }, [onlineReservation]);

  return (
    <>
      {loading && (
        <div className={"text-center"}>
          <Spinner
            className={"text-center mb-2"}
            animation="border"
            variant="primary"
          />
          <h3>{t("pay.please_wait")}</h3>
        </div>
      )}
    </>
  );
};

export default OnlineReservationPayPage;
